let modalId = 1;
export function makeModal(type, options) {
    return {
        id: modalId++,
        type,
        options
    };
}
